import { Component } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { FaIconComponent } from '@fortawesome/angular-fontawesome'

import { FabHoldReason, RepositoryModal } from '../../shared'

@Component({
    templateUrl: './fab-hold-reason.component.html',
    standalone: true,
    imports: [FormsModule, FaIconComponent],
})
export class FabHoldReasonComponent extends RepositoryModal<FabHoldReason> {
    protected onInitialized(): void {
        if (this.isAdding || this.isDuplicating) {
            if (!this.target.id) this.target.id = crypto.randomUUID()
            if (this.target.active === undefined) this.target.active = true
            if (this.target.sortOrder === undefined) this.target.sortOrder = 0
        }
    }
}
